import { getProfessionsGroup } from './GetProfessionsGroup/index';
import { getSkillsByAI } from './GetSkillsByAI';

export const professionsGroupServices = {
  getProfessionsGroup,
  getSkillsByAI,
};
